import { SHIPPING_METHOD } from "../../../../constants";

export const StorePickup = ({ tabRef, handleChangeMethod }) => {
  return (
    <div className="nav-item delivery-method-item" role="presentation">
      <div
        ref={tabRef}
        className="nav-link"
        id="pills-store-tab"
        data-bs-toggle="pill"
        data-bs-target="#pills-store"
        type="button"
        role="tab"
        aria-controls="pills-store"
        aria-selected="false"
        onClick={(e) => {
          handleChangeMethod(e, SHIPPING_METHOD[2]);
        }}
      >
        <div className="delivery-selection">
          <p className="choose-checkout" />
          <h6>Pickup in Store</h6>
        </div>
        <span className="wes-checkout-store" />
      </div>
    </div>
  );
};
